import { render, staticRenderFns } from "./TabCliente.vue?vue&type=template&id=bebd12da&"
import script from "./TabCliente.vue?vue&type=script&lang=js&"
export * from "./TabCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports